import { MetricStage } from './utils/monitor/metric.ts';
import { stringifyError } from './utils/helper/index.ts';

/**
 * 每次只需在fishdata后面补最新的钓鱼参数即可
 */
const fishdata = [
  {
    akka: '1000113',
  },
];

const needFishCheckType = [
  'gee_slide',
  'gee_click',
  'slide',
  'click',
  'email_captcha',
  'sms_captcha',
  'js_challenge',
  'strength_captcha',
  'phone_captcha_custom',
];

/**
 *
 * @param validate_type 传入的验证类型
 * @returns
 */
export const fishMap = (validate_type: string) => {
  if (
    !validate_type ||
    !needFishCheckType.includes(validate_type) ||
    fishdata.length < 1
  )
    return {};

  return fishdata[fishdata.length - 1];
};

/**
 *
 * @param validate_type
 * @returns 额外参数的param
 */
export const extraMap = (validate_type: string) => {
  if (!validate_type) return {};
  return {
    extra_param: {
      ...fishMap(validate_type),
    },
  };
};

export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  // 优先检测现代API
  if (window.matchMedia) {
    const mediaQuery = window.matchMedia('(pointer:coarse)');
    if (mediaQuery.matches) return true;
  }

  // 备选检测方案
  return (
    (window.innerWidth <= 768 && 'ontouchstart' in window) ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  );
};

export const getDeviceInfo = (options, scene, monitor) => {
  if (typeof window === 'undefined') {
    return Promise.resolve({});
  }

  if (
    !options?.validate_param?.is_collect_device_info ||
    !options?.validate_param?.device_info_timeout
  ) {
    return Promise.resolve({});
  }

  if (!window.RiskSpiderDeviceWing && !window.AntiDevices) {
    return Promise.resolve({});
  }

  const timeout = Number(options?.validate_param?.device_info_timeout) || 3000;

  const devicePromise = new Promise((resolve, reject) => {
    try {
      if (window.RiskSpiderDeviceWing) {
        window.RiskSpiderDeviceWing.postBridge('RiskBridge/getDeviceInfo', {
          timeout,
          scene: scene === 'validation_resource' ? '1' : '2',
        }).then((result) => {
          if (result?.deviceInfo) {
            resolve({
              dev_info: result?.deviceInfo,
            });
          } else {
            resolve({});
          }
        });
      } else if (window.AntiDevices && window.AntiDevices.report) {
        window.AntiDevices.report(scene).then((info) => {
          resolve({
            dev_info: info,
          });
        });
      }
    } catch (e) {
      monitor?.addErrorInfo(
        `scene: ${scene},loading device error:` + stringifyError(e)
      );
      resolve({});
    }
  });

  const setPromise = new Promise((resolve) => {
    setTimeout(() => {
      resolve({});
    }, timeout);
  });

  const result = Promise.race([devicePromise, setPromise]);

  return result;
};
